import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/yimo-img/appdownload-ios.png'
import _imports_1 from '../assets/img/yimo-img/xcx.png'
import _imports_2 from '../assets/img/yimo-img/appdownload-adr.png'
import _imports_3 from '../assets/img/yimo-img/appdownload-pc.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-10bc80a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn" }
const _hoisted_2 = { class: "appDown" }
const _hoisted_3 = { class: "appEwm" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "appEwmPng"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "andDowm" }
const _hoisted_7 = { class: "appEwm" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "appEwmPng"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["href"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "downloadBtn",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "downloadBtn",
        onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showEwm(1))),
        onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeEwm(1))),
        src: _imports_0,
        alt: ""
      }, null, 32),
      _withDirectives(_createElementVNode("div", _hoisted_3, _hoisted_5, 512), [
        [_vShow, _ctx.isAppshow]
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("img", {
        class: "downloadBtn",
        onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showEwm(2))),
        onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeEwm(2))),
        src: _imports_2,
        alt: ""
      }, null, 32),
      _withDirectives(_createElementVNode("div", _hoisted_7, _hoisted_9, 512), [
        [_vShow, _ctx.isAndShow]
      ])
    ]),
    _createElementVNode("a", {
      href: 
        _ctx.getSignedUrl(
          'https://cdnsource.bugegaming.com/pc/update/windows/buge-pc-manager/buge-live-pc.exe'
        )
      
    }, _hoisted_12, 8, _hoisted_10)
  ]))
}